import { formatDate } from '../../lib/datetime';
import { colors } from '../../styles/theme';
import type { NavValuation } from '../../types/finance';

/** A holding of a series priced at NAV: the units, the value of one unit and the date of the
 *  valuation the balance stands on (FI-17). */
export default function HoldingValuation({
  nav,
  currency,
}: Readonly<{ nav: NavValuation; currency: string }>): JSX.Element {
  return (
    <dl className="text-xs mt-2 grid grid-cols-2 gap-x-3 gap-y-1" style={{ color: colors.inkSoft }}>
      <dt style={{ color: colors.muted }}>Units</dt>
      <dd className="font-mono text-right">{nav.units}</dd>
      <dt style={{ color: colors.muted }}>Value per unit</dt>
      <dd className="font-mono text-right">
        {nav.value_per_unit} {currency}
      </dd>
      <dt style={{ color: colors.muted }}>Valued on</dt>
      <dd className="text-right">{formatDate(nav.as_of)}</dd>
    </dl>
  );
}
